module.exports = __webpack_public_path__ + "static/media/shark_fin.eb244b7d.png";